import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import { ListaDTO } from '../dtos/lista-DTO';
import {
  DatosAdicionalesPersonaDTO,
  GetDatoAdicionalesPersonaDTO,
} from '../dtos/datos-adicionales-persona-DTO';
import {
  DatosAdicionalesAbogadoDTO,
  GetDatosAdicionalesAbogadoDTO,
} from '../dtos/datos-adicionales-abogado-DTO';
import { DepartmentoDto } from '../../../../dto/expediente/departmento.dto';
import { MunicipioDto } from '../../../../dto/expediente/municipio.dto';

@Injectable({
  providedIn: 'root',
})
export class DatosAdicionalesService {
  urlListas: string = `${environment.apiUrl}/lista`;
  urlPersona: string = `${environment.apiUrl}/datoadicionalpersona`;
  urlAbogado: string = `${environment.apiUrl}/datoadicionalabogado`;

  constructor(private http: HttpClient) {}

  // BehaviorSubject para activar la guía interactiva en el momento que se guardan los datos adicionales
  private dataSource = new BehaviorSubject<boolean>(false);
  mostrarGuia = this.dataSource.asObservable();
  activarGuia(activar: boolean) {
    this.dataSource.next(activar);
  }
  getTipoArea(): Observable<ListaDTO[]> {
    return this.http
      .get<ListaDTO[]>(`${this.urlListas}/listavalor/Tipo_area`)
      .pipe();
  }

  getGenero(): Observable<ListaDTO[]> {
    return this.http
      .get<ListaDTO[]>(`${this.urlListas}/listavalor/Genero`)
      .pipe();
  }

  getEstratoSocioeconomico(): Observable<ListaDTO[]> {
    return this.http
      .get<ListaDTO[]>(`${this.urlListas}/listavalor/Estrato_socioeconomico`)
      .pipe();
  }

  getGrupoEtnico(): Observable<ListaDTO[]> {
    return this.http
      .get<ListaDTO[]>(`${this.urlListas}/listavalor/Grupo_Etnico`)
      .pipe();
  }

  getNivelEducativo(): Observable<ListaDTO[]> {
    return this.http
      .get<ListaDTO[]>(`${this.urlListas}/listavalor/Nivel_educativo`)
      .pipe();
  }

  getOcupacion(): Observable<ListaDTO[]> {
    return this.http
      .get<ListaDTO[]>(`${this.urlListas}/listavalor/Ocupacion`)
      .pipe();
  }

  getDiscapacidad(): Observable<ListaDTO[]> {
    return this.http
      .get<ListaDTO[]>(`${this.urlListas}/listavalor/Discapacidad`)
      .pipe();
  }

  getNivelTecnologia(): Observable<ListaDTO[]> {
    return this.http
      .get<ListaDTO[]>(`${this.urlListas}/listavalor/Nivel_tecnologia`)
      .pipe();
  }

  getListaGraduacion(): Observable<number[]> {
    return this.http
      .get<number[]>(`${this.urlListas}/Graduacion`)
      .pipe();
  }

  getDepartmentList(idCountry: number): Observable<DepartmentoDto[]> {
    return this.http.get<DepartmentoDto[]>(
      `${this.urlListas}/departamentos/${idCountry}`
    );
  }

  getMunicipalityList(idDepartment: number): Observable<MunicipioDto[]> {
    return this.http.get<MunicipioDto[]>(
      `${this.urlListas}/municipios/${idDepartment}`
    );
  }

  getConsultoriosJuridicos(): Observable<ListaDTO[]> {
    return this.http.get<ListaDTO[]>(
      `${this.urlListas}/listavalor/Consultorio_juridico`
    );
  }

  guardarDatosProvisionalesPersona(json: DatosAdicionalesPersonaDTO) {
    return this.http.post(`${this.urlPersona}/guardar`, json).pipe();
  }

  guardarDatosProvisionalesAbogado(json: DatosAdicionalesAbogadoDTO) {
    return this.http.post(`${this.urlAbogado}/guardar`, json).pipe();
  }

  getDataPersona(idPersona: number): Observable<GetDatoAdicionalesPersonaDTO> {
    return this.http.get<GetDatoAdicionalesPersonaDTO>(
      `${this.urlPersona}/consultar/${idPersona}`
    );
  }

  getDataAbogado(idPersona: number): Observable<GetDatosAdicionalesAbogadoDTO> {
    return this.http.get<GetDatosAdicionalesAbogadoDTO>(
      `${this.urlAbogado}/consultar/${idPersona}`
    );
  }
}
